/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import BreadCrumbs, { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import type { BlogMeta } from '../types';

const imageContainerStyles = xcss({
	paddingInline: 'space.300',
});

const imageStyles = css({
	width: '100%',
	minWidth: '0',
	borderRadius: token('radius.xlarge'),
});

export const BlogBanner = ({ meta }: { meta: BlogMeta }) => {
	return (
		<div>
			<Box paddingInline="space.300" paddingBlock="space.150">
				<BreadCrumbs>
					<BreadcrumbsItem href="/whats-new" text="What's new" />
					<BreadcrumbsItem href={meta.href} text={meta.title} />
				</BreadCrumbs>
			</Box>
			<Box xcss={imageContainerStyles}>
				<img css={imageStyles} src={meta.image} alt="Banner" />
			</Box>
		</div>
	);
};
